import { FiPlus } from "react-icons/fi";
import { getImageUrl } from "src/Common/common";

/**
 * `isPrimary` renders the solid blue variant. Opt-in rather than the default so
 * the pages that already share this component keep the outlined look.
 *
 * `testId` is for the E2E suite, `dataTour` for the Knowledge Base walkthrough
 * (Azure 416). They are separate on purpose: one is a test contract, the other
 * a product feature, and either may be renamed without touching the other.
 */
function CreateButton({ onClicked, title = "CREATE", isPrimary = false, testId, dataTour }) {
  return (
    <div
      onClick={onClicked}
      data-testid={testId}
      data-tour={dataTour}
      className={`rounded-[4px] flex items-center gap-2 px-[10px] h-[24px] cursor-pointer justify-between ${
        isPrimary ? "bg-blueColor border-none" : "border-borderColor border-[1px]"
      }`}
    >
      {/* The blue variant draws the plus as a vector so it takes the button's
          text colour. The asset named white_plus.png is actually grey
          (128,134,158), so it reads as dim on blue. Feather's plus is used
          rather than Ionicons' because its stroke width is settable — at this
          size the default weight almost disappears against the blue. The
          outlined variant keeps the original image so the pages sharing this
          button are unchanged. */}
      {isPrimary ? (
        <FiPlus size={14} strokeWidth={3.5} className="text-white" />
      ) : (
        <img src={getImageUrl("/images/common/plus.png")} className="w-[10px]" alt="" />
      )}
      <span
        className={`font-OpenSansRegular text-[12px] font-[600] ${
          isPrimary ? "text-white" : "text-[#67737E]"
        }`}
      >
        {title}
      </span>
    </div>
  );
}

export default CreateButton;
